import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { org_assessment_list_loading : true, org_assessment_list: '', org_assessment_list_error: false};

export function groupReportOrganisationAsessment(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_GROUP_REPORT_LIST:
        return {
            org_assessment_list_loading: true,
            org_assessment_list: '',
            org_assessment_list_error: false
        };
      case organisationConstants.RECIEVE_GROUP_REPORT_LIST:
        return {
            org_assessment_list_loading: false,
            org_assessment_list: action.org_assessment_list,
            org_assessment_list_error: false
        };
      case organisationConstants.ERROR_GROUP_REPORT_LIST:
        return { 
            org_assessment_list_loading: false,
            org_assessment_list: '',
            org_assessment_list_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/groupReport.reducer.js